import "./EventDetailPage.css";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import DefaultPage from "../DefaultPage/DefaultPage";
import Introduction from "../../components/Introduction";
import { useParams } from "react-router-dom";
// import { useState } from "react";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import {
  Download,
  Fullscreen,
  Thumbnails,
  Video,
} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Loader from "../../components/Loader";
import Document from "../DocumentsPage/Document.js";

const EventDetailPage = () => {
  // index pro sledovani lightboxu
  const [index, setIndex] = useState(-1);

  // parametry ktere dostavame z url adresy (id)
  const params = useParams();
  const { id } = params;

  //fetch udalosti
  const { loading, error, data } = useFetch(
    `${config.api}/api/events/${id}?populate=*`
  );
  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání událostí" />;

  //? test
  //? console.log("udalosti", data);

  //kontrola jestli fetch pro dane id plati -> jinak default page s hlaskou nenalezeno
  if (!data || !data.data) return <DefaultPage message="Projekt nenalezen" />;

  //vytvoreni noveho pole pro media z duvodu, ze lightbox potrebuje jiny format JSONU nez jaky dostaneme ze strapi
  //kontrola zdali jsou tam data - jelikoz pole medii je nepovinne
  const galleryData = data?.data?.gallery ?? [];
  const mediaEdited = [];

  for (let i = 0; i < galleryData.length; i++) {
    const item = galleryData[i];
    // kontrola nejdulezitejsich hodnot kdyby nahodou byl null
    const mime = item?.mime ?? "";
    const url = item?.url ?? "";
    const mediumUrl = item?.formats?.medium?.url ?? "";
    if (mime.startsWith("image")) {
      mediaEdited.push({
        id: item.id,
        type: "image",
        alternativeText: item.alternativeText,
        src: `${config.api}${url}`,
        medium: `${config.api}${mediumUrl}`,
      });
    } else if (mime.startsWith("video")) {
      mediaEdited.push({
        id: item.id,
        type: "video",
        alternativeText: item.alternativeText,
        title: item.title || "Video Title",
        description: item.description || "Video Description",
        width: 1280, // Adjust as needed
        height: 720, // Adjust as needed
        poster: `/images/video-icon.png`, // defaultni náhled
        sources: [
          {
            src: `${config.api}${url}`,
            type: mime,
          },
        ],
      });
    }
  }
  //uprava datumu
  const dateFrom = data?.data?.from ? new Date(data?.data?.from) : null;
  const dateTo = data?.data?.to ? new Date(data?.data?.to) : null;

  const dayFrom = dateFrom ? String(dateFrom.getDate()).padStart(2, "0") : "00";
  const monthFrom = dateFrom
    ? dateFrom.toLocaleString("default", { month: "long" })
    : "Invalid";
  const yearFrom = dateFrom ? dateFrom.getFullYear() : "0000";

  const dayTo = dateTo ? String(dateTo.getDate()).padStart(2, "0") : "00";
  const monthTo = dateTo
    ? dateTo.toLocaleString("default", { month: "long" })
    : "Invalid";
  const yearTo = dateTo ? dateTo.getFullYear() : "0000";

  //? test
  //? console.log(mediaEdited);

  //změna titulku stránky v prohlížeči
  document.title = data.data.name;

  return (
    <div className="min-height-100 d-flex flex-column">
      <Navbar />
      <Introduction title="PROJEKT" text="" />
      <div className="container-fluid background-white">
        <div className="container container-background p-4 p-md-5">
          <h1>{data.data.name}</h1>
          <h3>
            {dateFrom !== null && (
              <>
                {dayFrom}. {monthFrom} {yearFrom}
              </>
            )}
            {dateTo !== null && (
              <>
                -{dayTo}. {monthTo} {yearTo}
              </>
            )}
          </h3>
          <BlocksRenderer
            content={Array.isArray(data?.data?.text) ? data.data.text : []}
            blocks={{
              image: ({ image }) => (
                <img
                  src={image.url}
                  alt={image.alternativeText}
                  className="blocks-renderer-img"
                />
              ),
              list: ({ children, format }) =>
                format === "unordered" ? (
                  <ul className="blocks-renderer-ul">{children}</ul>
                ) : (
                  <ol className="blocks-renderer-ol">{children}</ol>
                ),
            }}
          ></BlocksRenderer>
          <Lightbox
            plugins={[Download, Fullscreen, Thumbnails, Video]}
            open={index >= 0}
            close={() => setIndex(-1)}
            index={index}
            slides={mediaEdited}
          />

          {/* vykreslovani medii podle toho jestli to je video nebo obrazek, na videu nastaven defaultni nahled  */}
          {/* neni schvalne vycentrovano */}
          <div className="container d-flex flex-wrap">
            {mediaEdited.map((media, index) => (
              <div key={index} className="m-2 col-10 col-md-3">
                {media.type === "image" ? (
                  <img
                    src={media.src}
                    onClick={() => setIndex(index)}
                    alt={media.alternativeText}
                    className="media-thumbnail media-gallery"
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <img
                    src="/images/video-icon.png"
                    onClick={() => setIndex(index)}
                    alt={media.alternativeText}
                    className="media-thumbnail media-gallery"
                    style={{ cursor: "pointer" }}
                  />
                )}
              </div>
            ))}
          </div>
          {data.data.documents !== null && (
            <>
              <h3 className="mt-5">Ke stažení</h3>
              <div className="news-doc-container">
                {data.data.documents.map((doc) => (
                  <div key={doc.documentId} className="news-doc">
                    <Document name={doc.name} fileUrl={doc.url} />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default EventDetailPage;

